import { InputAdornment } from "@material-ui/core";
import React, { useMemo } from "react";
import { Form } from "react-final-form";
import EuroSymbolIcon from "@material-ui/icons/EuroSymbol";
import { Grid } from "@material-ui/core";

import { Button, FinalFormInputText } from "components";
import { getMandatoryFieldStatus, getNamesAndMetas, numberFieldValidator } from "utils";
import { IConsumptionCalculationForm, IConsumptionCalculationFormProps } from "./interfaces";
import { ConsumptionCalculationResult } from "../result-modal/result-modal";
import { useStyles } from "./form.styles";

export const initialValues: IConsumptionCalculationForm = {
  travelledDistance: "",
  usedLiters: "",
  literPrice: "",
};

export const ConsumptionCalculationForm = ({
  onModalClose,
  onReset,
  onSubmit,
  result,
}: IConsumptionCalculationFormProps) => {
  const classes = useStyles();
  const isOpen = useMemo(() => result !== null, [result]);

  return (
    <>
      <Form
        onSubmit={onSubmit}
        initialValues={initialValues}
        render={({ form, handleSubmit }) => {
          const { travelledDistance, usedLiters, literPrice } = getNamesAndMetas(
            initialValues,
            form
          );

          const travelledDistanceStatus = getMandatoryFieldStatus(travelledDistance.meta);
          const usedLitersStatus = getMandatoryFieldStatus(usedLiters.meta);
          const literPriceStatus = getMandatoryFieldStatus(literPrice.meta);

          return (
            <Grid container justify="center">
              <Grid item xs={10} sm={6} lg={3}>
                <form onSubmit={handleSubmit} className={classes.form}>
                  {result !== null && (
                    <ConsumptionCalculationResult
                      isOpen={isOpen}
                      onClose={onModalClose}
                      onReset={() => onReset(form)}
                      result={result}
                    />
                  )}

                  <FinalFormInputText
                    id="travelled-distance-input"
                    name={travelledDistance.name}
                    label="Distance parcourue"
                    status={travelledDistanceStatus}
                    className={classes.input}
                    validate={numberFieldValidator("distance parcourue")}
                    helperText={
                      travelledDistanceStatus === "ERROR" ? travelledDistance.meta.error : " "
                    }
                    startAdornment={
                      <InputAdornment position="start">
                        <InputAdornment position="start">
                          <span className={classes.letterStartAdornment}>Km</span>
                        </InputAdornment>
                      </InputAdornment>
                    }
                    isFullWidth
                  />
                  <FinalFormInputText
                    className={classes.input}
                    id="used-litter-input"
                    name={usedLiters.name}
                    label="Carburant utilisé"
                    status={usedLitersStatus}
                    validate={numberFieldValidator("carburant utilisé")}
                    helperText={usedLitersStatus === "ERROR" ? usedLiters.meta.error : " "}
                    startAdornment={
                      <InputAdornment position="start">
                        <span className={classes.letterStartAdornment}>Litres</span>
                      </InputAdornment>
                    }
                    isFullWidth
                  />

                  <FinalFormInputText
                    className={classes.input}
                    id="litter-price-input"
                    name={literPrice.name}
                    label="Prix du carburant"
                    status={literPriceStatus}
                    validate={numberFieldValidator("carburant utilisé")}
                    helperText={literPriceStatus === "ERROR" ? literPrice.meta.error : " "}
                    startAdornment={
                      <InputAdornment position="start">
                        <EuroSymbolIcon />
                      </InputAdornment>
                    }
                    isFullWidth
                  />

                  <Grid container justify="space-between" spacing={1}>
                    <Grid item xs={6}>
                      <Button type="submit" isFullWidth>
                        Calculer
                      </Button>
                    </Grid>

                    <Grid item xs={6}>
                      <Button
                        type="button"
                        isFullWidth
                        variant="outlined"
                        onClick={() => onReset(form)}
                      >
                        Reset
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </Grid>
            </Grid>
          );
        }}
      />
    </>
  );
};
